var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoProduct(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 325.1 262.8",
    style: {
      enableBackground: "new 0 0 325.1 262.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F2F2F2;}\n\t.st1{fill:none;stroke:#BABABA;stroke-width:2.3623;stroke-linecap:round;stroke-linejoin:round;}\n\t.st2{fill:#FFFFFF;stroke:#BABABA;stroke-width:2.3623;stroke-linecap:round;stroke-linejoin:round;}\n\t.st3{fill:#D2D2D2;}\n\t.st4{fill:#BABABA;}\n\t.st5{fill:#CFCFCF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M212,96.6c-19.8,0-39.9-0.8-58.7-6c-18.5-5.1-35.4-15.1-50.6-26.6C92.9,56.5,83.9,50.5,71,51.4 c-12.6,0.7-24.6,5.4-34.3,13.4c-16.3,14.3-13.9,40.8-7.3,59.4c9.8,28,39.7,47.6,65.2,60.2c29.4,14.7,61.6,23.2,94,28.1 c28.3,4.3,64.8,7.4,89.3-11.1c22.6-17,28.7-55.9,23.2-82.1c-1.3-7.7-5.5-14.7-11.6-19.7c-15.9-11.6-39.5-3.9-57.3-3.5 C225.5,96.4,218.8,96.6,212,96.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M164.6,258.5c47.9,0,86.7-2.4,86.7-5.4c0-3-38.8-5.4-86.7-5.4s-86.7,2.4-86.7,5.4 C77.9,256.1,116.7,258.5,164.6,258.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.2,44.5l30.7-2.6c3.8-0.3,7.7,0.7,10.8,2.8c3.2,2.1,5.5,5.3,6.7,9l29.4,98.5l-5.8,10.3 c-1.5,2.7-2.2,5.7-2.1,8.7c0.1,3,1,6,2.7,8.6c1.6,2.6,4,4.6,6.7,6c2.7,1.4,5.8,1.9,8.8,1.7l117.9-10"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M94.8,68.7l137-11.6c1.3-0.1,2.7,0.1,4,0.5c1.3,0.5,2.4,1.3,3.3,2.2c0.9,1,1.6,2.1,2,3.4c0.4,1.3,0.5,2.6,0.3,4 l-9.3,67c-0.3,2-1.2,3.9-2.7,5.3c-1.5,1.4-3.4,2.3-5.4,2.5l-104.3,10.2L94.8,68.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M143.3,210.1c6.1,0,11.1-5,11.1-11.1c0-6.1-5-11.1-11.1-11.1s-11.1,5-11.1,11.1 C132.1,205.1,137.1,210.1,143.3,210.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M220.7,203.6c6.1,0,11.1-5,11.1-11.1c0-6.1-5-11.1-11.1-11.1c-6.1,0-11.1,5-11.1,11.1 C209.6,198.6,214.6,203.6,220.7,203.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M66.5,39.3l-29,2.5c-2.5,0.2-4.4,2.4-4.2,4.9c0.2,2.5,2.4,4.4,4.9,4.2l29-2.5c2.5-0.2,4.4-2.4,4.2-4.9 C71.3,40.9,69.1,39.1,66.5,39.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M152.5,120.5c0.6-4.3,2.6-8.3,5.7-11.3c3.1-3,7.2-4.8,11.6-5.2c4.3-0.4,8.7,0.8,12.3,3.2 c3.6,2.4,6.3,6,7.6,10.2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M189.9,95c1.5,0,2.6-1.2,2.6-2.6s-1.2-2.6-2.6-2.6c-1.5,0-2.6,1.2-2.6,2.6S188.5,95,189.9,95z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M148,98.5c1.5,0,2.6-1.2,2.6-2.6s-1.2-2.6-2.6-2.6c-1.5,0-2.6,1.2-2.6,2.6S146.5,98.5,148,98.5z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.5,195.7v10.2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M68.4,200.8h10.2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M235.8,6.4v10.2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M230.7,11.5h10.2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M115.5,36.8V47"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M110.4,41.9h10.2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M261.1,74.1c1.3,0,2.4-1.1,2.4-2.4c0-1.3-1.1-2.4-2.4-2.4s-2.4,1.1-2.4,2.4C258.7,73.1,259.8,74.1,261.1,74.1z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M171.1,52.5c1.3,0,2.3-1,2.3-2.3s-1-2.3-2.3-2.3c-1.3,0-2.3,1-2.3,2.3S169.8,52.5,171.1,52.5z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M186.6,220.5c1.3,0,2.3-1,2.3-2.3s-1-2.3-2.3-2.3c-1.3,0-2.3,1-2.3,2.3S185.4,220.5,186.6,220.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoProduct);
export default __webpack_public_path__ + "static/media/no-product.a3aefc504ea7e11e9d2a6e8a979fde87.svg";
export { ForwardRef as ReactComponent };